import React from 'react';
import { Outlet } from 'react-router-dom';

type Props = {};

const SaleryPageLayout = (props: Props) => {
  return (
    <><Outlet /></>
  );
};

export default SaleryPageLayout;